module.exports = __webpack_public_path__ + "img/code.a0a284d6.png";